import { useQuery } from '@apollo/client';
import { gql } from '@/__generated__';
import { StreamTier, streamTiers } from '@/constants/stream-tiers';
import { useAppLoader } from '@/routes/_app/loader';

export const StreamTierAccessQuery = gql(`
  query StreamTierAccessQuery(
    $tier1Id: ID!
    $tier2Id: ID!
    $hasTier1: Boolean!
    $hasTier2: Boolean!
  ) {
    tier1: streamPackage(id: $tier1Id) @include(if: $hasTier1) {
      id
      subscription {
        active
      }
    }
    tier2: streamPackage(id: $tier2Id) @include(if: $hasTier2) {
      id
      subscription {
        active
      }
    }
  }
`);

export const streamTierAccessVariables = {
  tier1Id: streamTiers.tier1.packageId ?? '',
  tier2Id: streamTiers.tier2.packageId ?? '',
  hasTier1: streamTiers.tier1.packageId !== undefined,
  hasTier2: streamTiers.tier2.packageId !== undefined,
};

export const useStreamTier = (): StreamTier | null => {
  const { authenticated } = useAppLoader();
  const { tier1, tier2, tier3 } = streamTiers;

  const { data } = useQuery(StreamTierAccessQuery, {
    variables: streamTierAccessVariables,
    skip: !authenticated,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (!authenticated) return tier3;
  if (!data) return null;
  if (data.tier1?.subscription?.active) return tier1;
  if (data.tier2?.subscription?.active) return tier2;
  return tier3;
};
